// 커뮤니티 조회 컬럼 계약 — 서버의 컬럼 단위 GRANT와 1:1로 맞춘 정본.
//
// 🔴 `select('*')`를 쓰면 안 된다.
//   community_posts·community_comments는 **테이블 레벨 SELECT 권한이 없고 컬럼 단위 GRANT만** 있다.
//   PostgreSQL에서 `*`는 테이블 권한을 요구하므로, 모든 컬럼이 GRANT돼 있어도 `*`는
//   `42501 permission denied for table`로 **쿼리 전체가 실패**한다.
//   실제로 2026-08-30 이 이유로 커뮤니티 목록·글 상세·댓글이 통째로 죽어 있었다
//   (화면은 catch에서 빈 배열로 떨어져 "글이 없음"처럼 보였다 — 에러가 안 보이는 게 이 버그의 함정).
//
// 🔑 `password`(익명 글 수정·삭제용 비밀번호)는 **의도적으로 GRANT에서 제외**돼 있다.
//   여기에 절대 추가하지 말 것. 앱은 password를 읽지 않고, 쓰기(RPC 인자)로만 넘긴다.
//
// 컬럼을 추가·변경하면 서버 GRANT도 함께 갱신해야 한다. 확인 쿼리:
//   select column_name from information_schema.role_column_grants
//   where table_schema='public' and table_name='community_posts'
//     and grantee='authenticated' and privilege_type='SELECT';

/** community_posts에서 조회 가능한 17개 컬럼 (2026-08-30 라이브 GRANT 실측) */
export const POST_COLUMNS = [
  "id",
  "category",
  "subcategory",
  "title",
  "content",
  "content_format",
  "author",
  "author_id",
  "image_url",
  "tags",
  "likes",
  "views",
  "comment_count",
  "created_at",
  "updated_at",
  "edited_at",
  "edited_by",
].join(",");

/** community_comments에서 조회 가능한 11개 컬럼 (2026-08-30 라이브 GRANT 실측) */
export const COMMENT_COLUMNS = [
  "id",
  "post_id",
  "parent_comment_id",
  "content",
  "author",
  "author_id",
  "likes",
  "is_deleted",
  "created_at",
  "edited_at",
  "edited_by",
].join(",");
